import React from "react";

export type TableRecordStyleFields = {
  __backgroundColor?: string;
};

export type TableRecord = Record<string, React.ReactNode> & TableRecordStyleFields;

interface TableProps {
  records: TableRecord[];
  columnOrder?: string[];
}

export const Table: React.FC<TableProps> = ({ records, columnOrder }) => {
  if (records.length === 0) {
    return (
      <div className="overflow-x-auto">
        <div className="min-w-full bg-white border border-gray-200 p-4 text-center text-gray-500">No data to display</div>
      </div>
    );
  }

  const columns =
    columnOrder || Array.from(new Set(records.flatMap((record) => Object.keys(record).filter((key) => key !== "__backgroundColor"))));

  return (
    <div className={`max-h-[75vh]"} overflow-y-auto`} onWheel={(e) => e.stopPropagation()}>
      <table className="min-w-full bg-white border border-gray-200">
        <thead className="sticky top-0 z-10 bg-gray-200">
          <tr>
            {columns.map((column) => (
              <th key={column} className="px-4 py-2 text-left text-sm font-medium text-gray-700">
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {records.map((record, index) => {
            const rowStyle = record.__backgroundColor ? { backgroundColor: record.__backgroundColor } : undefined;

            return (
              <tr key={index} style={rowStyle}>
                {columns.map((column) => (
                  <td key={column} className="px-4 py-2 border-b text-sm text-gray-900">
                    {record[column]}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
